<template>
  <div>租赁详情</div>
</template>

<script>
export default {
  name: 'rentDetail'
}
</script>

<style scoped>

</style>
